import React from "react";
import { Reveal } from "./ui";

/** Very short bridge straight into the price block. */
export function OfferTransition() {
  return <section className="w-full bg-[#eef6ff] px-4 py-10 sm:px-8 sm:py-14" data-id="element-148" data-mp="1w2dzfg7kshe7">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-149" data-mp="206lpbgprs3e0">
        <h2 className="font-serif-display text-[1.6rem] font-semibold leading-tight tracking-[-0.02em] text-[var(--ink)] sm:text-3xl" data-id="element-150" data-mp="254n800jaa0oy">
          Todas las estrategias, en un solo lugar.
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-[var(--muted)] sm:text-base" data-id="element-151" data-mp="1cfy3drj0rd8g">
          6 guías + 3 recursos de emergencia para consultar cada vez que necesites otra forma de
          acompañar ese momento.
        </p>
      </Reveal>
    </section>;
}